import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import pluralize            from 'pluralize';

export default class MessageUsersStage2 extends Component {
  render() {
    const {
      cancelMessage,
      libraryName,
      updateMessageState,
      submitted,
      message
    } = this.props;

    if (this.props.stage !== 2) { return null; }

    return (
      <React.Fragment>
        <div className="section-title-container">
          <h3 className="section-title compose-message-title">{bfTranslate('Compose Message')}</h3>
          <span className="compose-message">
            {`Users will be notified by email and in their ${libraryName} notifications`}
          </span>
        </div>
        <div className="section-body body-write-message">
          <div className="message-container">
            <textarea
              id="compose-message"
              className="textareas"
              cols={100}
              value={message}
              onChange={(e) => updateMessageState({ message: e.target.value })}
            />
          </div>
        </div>
        <div className="button-container">
          <button
            className="button tertiary sm"
            onClick={() => cancelMessage()}
            type="button"
          >
            {bfTranslate('Cancel')}
          </button>
          <button
            className="button primary lg"
            onClick={() => updateMessageState({ stage: 3 })}
            disabled={submitted || !message}
            type="button"
          >
            {bfTranslate('Review')}
          </button>
        </div>
      </React.Fragment>
    );
  }
}

MessageUsersStage2.defaultProps = {
  libraryName: "Brandfolder"
};

MessageUsersStage2.propTypes = {
  libraryName: PropTypes.string,
  cancelMessage: PropTypes.func.isRequired,
  libraryName: PropTypes.string,
  stage: PropTypes.number.isRequired,
  submitted: PropTypes.bool.isRequired,
  updateMessageState: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired
};
